<template>
  <div>
    <v-dialog v-model="getConfirmDelete" persistent max-width="500">
      <v-card>
        <v-card-title
          :style="{ color: getThemeColor }"
          class="text-h5 lighten-2"
          >Confirm Delete</v-card-title
        >

        <v-card shaped elevation="12" outlined class="mx-10">
          <v-container>
            <v-row>
              <v-btn
                rounded
                class="mt-4 mb-10 mx-auto"
                :style="{ 'background-color': 'red', color: 'white' }"
                @click="deleteConfirmed(true)"
              >
                <v-icon left>mdi-times</v-icon>
                Delete {{ item }} ?
              </v-btn>
            </v-row>
          </v-container>
        </v-card>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <vButton
            color="warning"
            :data="false"
            :outlined="true"
            icon="mdi-cancel"
            label="No, Cancel"
            :small="true"
            @button-clicked="deleteConfirmed"
          ></vButton>

          <vButton
            class="ml-2"
            color="red"
            :data="true"
            :outlined="true"
            icon="mdi-delete"
            label="Yes, Delete"
            :small="true"
            @button-clicked="deleteConfirmed"
          ></vButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import vButton from "@/components/Legos/vButton.vue";

export default {
  props: {
    item: {
      default: "Item(s)",
    },
  },
  components: { vButton },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getConfirmDelete() {
      return this.$store.getters.getConfirmDelete;
    },
  },
  methods: {
    deleteConfirmed(choice) {
      this.$emit("delete-confirmed", choice);
      this.$store.commit("setConfirmDelete", false);
    },
  },
};
</script>

<style></style>
